import base from './base'
import { addErrorNotification } from '../utils/notifications'

export const getLocations = () => base.get('/location')
    .then(res => res.data)
    .catch(() => addErrorNotification('Unable to load <strong>Locations</strong>'))




// WEBPACK FOOTER //
// ./src/services/locations.js